<script setup>

import AppMenu from '@/components/AppMenu.vue'
import Icon from '@/components/Icon/Icon.vue'
import ReferenceIndexWidget from '@/components/widget/ReferenceIndexWidget.vue'
import SummaryAmountsWidget from '@/components/widget/SummaryAmountsWidget.vue'
import AppSystem from '@/components/AppSystem.vue'
import TaskWidget from '@/components/widget/TaskWidget.vue'

</script>

<template>
    <div class="flex">
        <div>
            <AppMenu active="main" />
        </div>
        <div class="m-4 grow w-1/3">
            <h2 class="flex text-3xl border-b border-rose-400">
                <Icon name="dashboard" color="black" class="mr-4 my-auto w-6 h-6" />
                Tableau de bord
            </h2>
            <div><AppSystem /></div>

            <div class="m-6 grid grid-cols-1 gap-6">
                <TaskWidget />
                <ReferenceIndexWidget />
                <SummaryAmountsWidget />
            </div>
        </div>
    </div>
</template>
